import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { utils } from '../helper/utils';
import { Observable } from 'rxjs';
import { BulkWOrkOrderRequest } from '../models/bulk-work-order/bulk-work-order-request.model';
import { BulkWorkOrderCompletionBody } from '../models/bulk-work-order/bulk-work-order-completion.model';
@Injectable({
  providedIn: 'root',
})
export class BulkWorkOrderService {
  constructor(private client: HttpClient) {}

  public postBulkWorkOrder(bulkWorkOrderRequestBody: BulkWOrkOrderRequest): Observable<{ id: string; createdAt: Date }> {
    return this.client.post<any>(utils.GetOrderAPIUrl('maintenance-orders/bulk-upload'), bulkWorkOrderRequestBody);
  }
  public postBulkWorkOrderCompletion(selectedWorkOrderIds: string[]): Observable<any> {
    return this.client.post<any>(utils.GetOrderAPIUrl('maintenance-orders/bulk-complete'), { workOrderIds: selectedWorkOrderIds });
  }
}
